import { watch, onBeforeUnmount } from 'vue'

const THRESHOLD = 30

const _attach = (el, handler, vertical) => {
  let startX = 0, startY = 0, active = false

  const onPointerDown = e => {
    if (e.button !== 0) return
    startX = e.clientX
    startY = e.clientY
    active = true
  }

  const onPointerUp = e => {
    if (!active) return
    active = false
    const dx = e.clientX - startX
    const dy = e.clientY - startY
    const absDx = Math.abs(dx)
    const absDy = Math.abs(dy)
    if (vertical) {
      if (absDy > THRESHOLD && absDy > absDx)
        handler({ direction: dy < 0 ? 'up' : 'down' })
    } else {
      if (absDx > THRESHOLD && absDx > absDy)
        handler({ direction: dx < 0 ? 'left' : 'right' })
    }
  }

  el.__swipe = { onPointerDown, onPointerUp }
  el.addEventListener('pointerdown', onPointerDown)
  window.addEventListener('pointerup', onPointerUp)
}

const _detach = el => {
  const s = el.__swipe
  if (!s) return
  el.removeEventListener('pointerdown', s.onPointerDown)
  window.removeEventListener('pointerup', s.onPointerUp)
  delete el.__swipe
}

const val = v => (v && typeof v === 'object' && 'value' in v ? v.value : v)

export const useSwipe = (elRef, handler, options = {}) => {
  let attached = false

  const sync = () => {
    const el = val(elRef)
    const enabled = val(options.enabled) !== false
    const vertical = !!val(options.vertical)
    if (attached) {
      _detach(val(elRef))
      attached = false
    }
    if (el && enabled) {
      _attach(el, handler, vertical)
      attached = true
    }
  }

  watch(
    [() => val(elRef), () => !!val(options.enabled), () => !!val(options.vertical)],
    sync,
    { immediate: true }
  )

  onBeforeUnmount(() => {
    const el = val(elRef)
    if (el && attached) {
      _detach(el)
      attached = false
    }
  })
}
